__turbopack_context__.v({
  "Header": "Header-module__pnOLXq__Header",
  "HeaderBottom": "Header-module__pnOLXq__HeaderBottom",
  "HeaderTop": "Header-module__pnOLXq__HeaderTop",
  "MobileFooter": "Header-module__pnOLXq__MobileFooter",
  "PageLinks": "Header-module__pnOLXq__PageLinks",
  "PageLinksSlide": "Header-module__pnOLXq__PageLinksSlide",
  "UserInfoCard": "Header-module__pnOLXq__UserInfoCard",
  "active": "Header-module__pnOLXq__active",
  "avatar": "Header-module__pnOLXq__avatar",
  "button": "Header-module__pnOLXq__button",
  "buttons": "Header-module__pnOLXq__buttons",
  "center": "Header-module__pnOLXq__center",
  "contents": "Header-module__pnOLXq__contents",
  "counter": "Header-module__pnOLXq__counter",
  "desktopMenu": "Header-module__pnOLXq__desktopMenu",
  "dot": "Header-module__pnOLXq__dot",
  "fadeIn": "Header-module__pnOLXq__fadeIn",
  "header": "Header-module__pnOLXq__header",
  "hr": "Header-module__pnOLXq__hr",
  "icon": "Header-module__pnOLXq__icon",
  "item": "Header-module__pnOLXq__item",
  "left": "Header-module__pnOLXq__left",
  "link": "Header-module__pnOLXq__link",
  "links": "Header-module__pnOLXq__links",
  "logo": "Header-module__pnOLXq__logo",
  "menuButton": "Header-module__pnOLXq__menuButton",
  "mobile": "Header-module__pnOLXq__mobile",
  "mobileMenu": "Header-module__pnOLXq__mobileMenu",
  "name": "Header-module__pnOLXq__name",
  "nav": "Header-module__pnOLXq__nav",
  "offerBtn": "Header-module__pnOLXq__offerBtn",
  "outlineIcon": "Header-module__pnOLXq__outlineIcon",
  "parent": "Header-module__pnOLXq__parent",
  "py": "Header-module__pnOLXq__py",
  "right": "Header-module__pnOLXq__right",
  "rightArrow": "Header-module__pnOLXq__rightArrow",
  "rightButtons": "Header-module__pnOLXq__rightButtons",
  "text": "Header-module__pnOLXq__text",
  "title": "Header-module__pnOLXq__title",
  "titleBtn": "Header-module__pnOLXq__titleBtn",
  "top": "Header-module__pnOLXq__top",
  "user": "Header-module__pnOLXq__user",
  "userInfoCard": "Header-module__pnOLXq__userInfoCard",
});
